module.exports = __webpack_public_path__ + "img/portfolio-home.964f4b5d.webp";